/* ================================================================
   SCENTURIES — CRO additions (runtime DOM enhancements)
   New supplementary script. Does not modify any existing file.
   ================================================================ */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    /* ---------- 1. Hero CTA: add a real, clickable "Shop Now" button
       over the hero slideshow, since the current hero has no headline,
       subheading, or button configured. Links to the full catalog.
       HOMEPAGE ONLY — gated on window.__SC_PAGE_TYPE, set from Liquid's
       request.page_type in theme.liquid, so this never runs on product,
       collection, cart, contact, search, or policy pages. ---------- */
    try {
      if (window.__SC_PAGE_TYPE === 'index') {
        var firstSection = document.querySelector('#MainContent > .shopify-section:first-child');
        if (firstSection && !firstSection.querySelector('.sc-hero-cta-wrap')) {
          var wrap = document.createElement('div');
          wrap.className = 'sc-hero-cta-wrap';
          var a = document.createElement('a');
          a.className = 'sc-hero-cta';
          a.href = '/collections/all';
          a.innerHTML = 'Shop Now <svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
          wrap.appendChild(a);
          firstSection.appendChild(wrap);
        }
      }
    } catch (e) { /* fail silently, never break the page */ }

    /* ---------- 2. Footer payment badges: remove any badge that is not
       COD, since VISA / Mastercard / Easypaisa are not currently active.
       Done here (not by editing templates/index.json) to avoid the
       whole-file-reconstruction risk on that large file. ---------- */
    try {
      document.querySelectorAll('.scf-pay-badge').forEach(function (badge) {
        var label = (badge.textContent || '').trim().toUpperCase();
        if (label !== 'COD') {
          badge.remove();
        }
      });
    } catch (e) { /* fail silently */ }

    /* ---------- 3. FAQ: remove the "Do you offer gift packaging?" item
       (question + its answer together, as one .scf-item unit) per client
       request. All other FAQ items are left completely untouched. Done
       here rather than editing templates/index.json (83KB+, unsafe to
       reconstruct) — same pattern as the footer badge fix above. Matches
       on exact question text, case-insensitive, so it will not remove
       any other FAQ item by accident. ---------- */
    try {
      var TARGET_FAQ_Q = 'do you offer gift packaging?';
      document.querySelectorAll('.scf-item').forEach(function (item) {
        var qBtn = item.querySelector('.scf-q');
        if (!qBtn) return;
        var qText = (qBtn.textContent || '').trim().toLowerCase();
        if (qText === TARGET_FAQ_Q) {
          item.remove();
        }
      });
    } catch (e) { /* fail silently */ }

  });
})();
